import { render, staticRenderFns } from "./grantSegment.vue?vue&type=template&id=eb6adbe2&scoped=true&"
import script from "./grantSegment.vue?vue&type=script&lang=js&"
export * from "./grantSegment.vue?vue&type=script&lang=js&"
import style0 from "./grantSegment.vue?vue&type=style&index=0&id=eb6adbe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6adbe2",
  null
  
)

export default component.exports